import { render, staticRenderFns } from "./SignerInputField.vue?vue&type=template&id=612ab583&"
import script from "./SignerInputField.vue?vue&type=script&lang=ts&"
export * from "./SignerInputField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports